const convertBalance = (value: number): string => value.toFixed(2);

export default convertBalance;
